<template>
  <div>
    <PPPlayerDefault :airplay="airplay" :chromecast="chromecast"
                     :track-hovering="!asset || !asset.vr || !asset.vr.enable"
                     :auto-hide-ui="autoHideUi"
                     :fullscreenThumbs="fullscreenThumbs"
                     ref="container" class="player-container" :class="{'no-source': !asset || !asset.source.url}">
      <video ref="video" @click="playerClick" :playsinline="playsinline"></video>
      <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
      <div slot="title">
        <div v-if="player.fullscreen"
             style="display: flex; height: 32px; line-height: 32px;">
          <div style="margin-left: 20px">{{title}}</div>
        </div>
        <div v-else
             style="display: flex; height: 32px; line-height: 32px;">
          <div>{{title}}</div>
        </div>
      </div>

      <div class="pp-ui-row" slot="controls-top" style="flex-wrap: nowrap;">
        <slot name="title">
          <div v-html="title" class="pp-ui-title"></div>
        </slot>
        <div style="flex-grow: 1"></div>
        <PPButtonCast :chromecast="chromecast" class="pp-ui-button-22" style="margin-right: 16px"/>
        <PPButtonAirPlay :airplay="airplay" class="pp-ui-button-22" style="margin-right: 16px"/>
        <PPButtonToggleFullscreen class="pp-ui-button-22" style="margin-right: 16px"/>
        <PPButtonOptions class="pp-ui-button-22"/>
      </div>

      <div slot="controls-center" style="flex-grow: 1; display: flex;" @click="playerClick">
      </div>

      <div slot="controls-bottom" v-if="!player.fullscreen">
        <div class="pp-ui-row" style="background-color: transparent; padding: 0" v-if="!fullscreenThumbs">
          <PPThumbnail :thumb-width="thumbWidth"/>
        </div>
        <div class="pp-ui-row">
          <PPBarHorizontalSeek style="width: 100%; height: 24px;"
                               :apply-styles="false"
                               :unset-hover-after-seek="true"/>
          <PPButtonTogglePlayPause class="pp-ui-button-22" style="margin-right: 16px;">
            <PlayIconSmall slot="play" />
            <PauseIconSmall slot="pause"/>
          </PPButtonTogglePlayPause>
          <div style="flex-basis: 0; flex-grow: 1; text-align: left;">
            <PPLabelCurrentTime />
            <span>&nbsp;/&nbsp;</span>
            <PPLabelDuration />
          </div>
          <PPButtonToggleMuted class="pp-ui-button-22" />
        </div>

      </div>
    </PPPlayerDefault>
  </div>
</template>

<script>
import { PPPKeyboardMixin, PPPlayerMethodsMixinRoot, PPPlayerWebMixin, PPCastProxyMixin, PPAirPlayMixin, initMixins } from '../../../../submodules/prestoplay-web-ui-vue/src/mixins';
import PPPlayerDefault from '../../../../submodules/prestoplay-web-ui-vue/src/components/PPPlayerDefault';
import PPButtonTogglePlayPause from '../../../../submodules/prestoplay-web-ui-vue/src/components/PPButtonTogglePlayPause';
import PPButtonToggleMuted from '../../../../submodules/prestoplay-web-ui-vue/src/components/PPButtonToggleMuted';
import PPBarHorizontalSeek from '../../../../submodules/prestoplay-web-ui-vue/src/components/PPBarHorizontalSeek';
import PPLabelDuration from '../../../../submodules/prestoplay-web-ui-vue/src/components/PPLabelDuration';
import PPLabelCurrentTime from '../../../../submodules/prestoplay-web-ui-vue/src/components/PPLabelCurrentTime';
import PPButtonOptions from '../../../../submodules/prestoplay-web-ui-vue/src/components/PPButtonOptions';
import PPButtonToggleFullscreen from '../../../../submodules/prestoplay-web-ui-vue/src/components/PPButtonToggleFullscreen';
import PPButtonCast from '../../../../submodules/prestoplay-web-ui-vue/src/components/PPButtonCast';
import PPButtonAirPlay from '../../../../submodules/prestoplay-web-ui-vue/src/components/PPButtonAirPlay';
import PlayIconSmall from '../../../../submodules/prestoplay-web-ui-vue/src/style/assets/play.svg';
import PauseIconSmall from '../../../../submodules/prestoplay-web-ui-vue/src/style/assets/pause.svg';
import PPThumbnail from '../../../../submodules/prestoplay-web-ui-vue/src/components/PPThumbnail';

import '../../../../submodules/prestoplay-web-ui-vue/src/style/pp-ui-styles.css';
import { createPlayerConfig } from '../../utils/player';

export default {
  name: 'Player',
  mixins: [
    PPPlayerWebMixin,
    PPPlayerMethodsMixinRoot,
    PPPKeyboardMixin,
    PPCastProxyMixin,
    PPAirPlayMixin
  ],
  props: {
    asset: {
      type: Object,
      default: null
    },
    fullscreenThumbs: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PPPlayerDefault,
    PPButtonTogglePlayPause,
    PlayIconSmall,
    PauseIconSmall,
    PPButtonToggleMuted,
    PPBarHorizontalSeek,
    PPLabelCurrentTime,
    PPLabelDuration,
    PPButtonOptions,
    PPButtonToggleFullscreen,
    PPButtonCast,
    PPButtonAirPlay,
    PPThumbnail
  },
  watch: {
    asset: function (newValue, oldValue) {
      // The value here can get passed from outside for instance as a
      // query parameter in a higher up component. That means that the
      // object changed also on nested router view changed. In case
      // we loaded the asset already, we do not want to reload it here
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.load();
      }
    }
  },
  computed: {
    title () {
      if (this.asset) {
        if (this.asset.metadata) {
          return this.asset.metadata.title;
        }
      }
      return '';
    },
    thumbWidth () {
      if (!this.ppContainer || !this.player) {
        return 0;
      }
      const height = this.ppContainer.offsetHeight;
      return height < 300 && !this.player.fullscreen ? 65 : 200;
    },
    autoHideUi () {
      return this.$store.state.player_settings.autoHideUi;
    },
    playsinline () {
      return this.$store.state.player_settings.playsInline;
    }
  },
  mounted () {
    // Initialize the mixins module
    initMixins(clpp);

    const config = {
      license: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJ1cmxzIjpbIjovL2Nhc3RsYWJzLmNvbSJdLCJ0eXBlIjoiV2ViIiwia2lkIjoxOTUwLCJpbHYiOmZhbHNlfQ.jzGGRcbFr_2QET-4tbMcpR5pSaj7eV7X2d1HWw_VKQpPg3zCwSZSDuqw225dIYyAYwLSiElbozbZPSArkBXOsoUm-KZRUPF4m7WG0T7Uza5G-QaQw57BbbfcSsooSpatC997kHKLMTjO71By9Olcu5ykN164nZpGQtZNzQjYag-bnUaMVI5vvhzjlvDihORQ9V_qRlEh0-mpoz6W0-36HGAbWIXWq0kxPh6inbovby-ZmFpqGrVjWOEFa55EARZXPNW9ERupW5xrrYHZdwwTpdRTY5IwEnobS85yTrLhK8Y2MV4jlQLTtQp372fKDsuU6q6_4XvmNq1SgAoKoaf41g',
      adobe: {
        enabled: false,
      }
    };
    const ppPlayer = this.initPlayer(this.$refs.video, this.$refs.container.$el, config);
    ppPlayer.on('error', (event) => {
      this.$emit('error', event);
    });
    ppPlayer.on(clpp.events.LOAD_START, () => {
      this.$emit('loaded', true);
    });
    ppPlayer.on(clpp.events.RELEASING, () => {
      this.$emit('loaded', false);
    });

    // DE-7754 Revisit this for Safari, where casting is not supported.
    this.setCastProxy();
    this.$emit('player', { ppPlayer: this.ppPlayerRef, player: this.player, castProxy: this.castProxy });
    this.initAirPlay();

    this.load();
  },
  methods: {
    async refreshToken (asset) {
      asset = asset || this.asset;
      if (asset && asset.id && asset.drm && asset.drm.customData && asset.drm.customData.authToken) {
        const token = await this.$store.getters['assetdb/getAuthToken'](asset.id);
        return clpp.utils.PlayerConfiguration.create(asset, { drm: { customData: { authToken: token } } });
      }
    },
    async resumePlayback (state, config) {
      if (state !== clpp.Player.State.ENDED && state !== clpp.Player.State.IDLE) {
        let newConfig;
        try {
          newConfig = await this.refreshToken(config);
        } finally {
          this.load(newConfig || config);
        }
      }
    },
    setCastProxy (CCReceiverId) {
      if (this.castProxy) this.castProxy = null;
      const id = CCReceiverId || process.env.VUE_APP_RECEIVER_ID;
      this.castProxy = this.initCastProxy(this.ppPlayerRef.get(), id, this.resumePlayback);
      this.castProxy.setPlayerConfigInterceptor(this.refreshToken);
    },
    playerClick () {
      if (this.player.ad.active) {
        return;
      }

      if (this.autoHideUi) {
        // If auto-hide is enabled, we toggle play/pause if we are not
        // in idle or error state
        if (this.player.status !== 'idle' && this.player.status !== 'error') {
          this.togglePlayPause();
        }
      } else {
        // If auto hiding the UI is disabled, a click on the surface
        // will toggle the display of the UI controls
        this.player.showControls = !this.player.showControls;
      }
    },
    load (asset) {
      asset = asset || this.asset;
      if (!asset) return;
      if (!this.player) return;
      // DE-7754 Revisit this for Safari, where casting is not supported.
      if (asset.CCReceiverId) this.setCastProxy(asset.CCReceiverId);
      asset = createPlayerConfig(asset, true);
      if (asset.source) {
        console.log('Loading configuration', asset);
        this.ppPlayerRef.get().load(asset).catch((error) => {
          console.error('Error while loading content', error);
          this.$emit('error', { detail: error });
        });
        const headers = asset.headers || [];
        this.ppPlayerRef.get().getNetworkEngine().addRequestModifier(function (request) {
          for (const header of headers) {
            request.headers[header.name] = header.value;
          }
        });
      } else {
        console.log('No source provided, release player.');
        this.ppPlayerRef.get().release().catch((error) => {
          console.error('Error while releasing', error);
          this.$emit('error', { detail: error });
        });
      }
    },
  },
  destroyed () {
    this.ppPlayerRef = null;
    this.player = null;
    this.castProxy = null;
    this.$emit('player', { ppPlayer: null, player: null, castProxy: null });
  }
};
</script>

<style lang="scss">
  @import "../../style/color_";

  .pp-ui-container {
    /*background-color: white;*/
    max-width: none;
  }
  .player-container {
    position: relative;
  }
  .pp-ui-container:fullscreen {
    border: none;
  }
  .clpp-container {
    position: absolute !important;
  }

  .no-source {
    background-color: initial;
    border: none;
  }

  .pp-ui-container .pp-ui-show-controls .clpp-text-container {
    // 24px seek bar + 22px buttons + 20px padding top and bottom = 66px
    top: -66px !important;
    bottom: 66px !important;

    /* Disable the transition delay when moving the captions up, so that the
     * controls don't appear over the captions. */
    transition-delay: 0ms;
  }

  .pp-ui-container:fullscreen .pp-ui-show-controls .clpp-text-container {
    // 40px seek bar + 64px buttons + 20px padding top and bottom = 124px
    top: -124px !important;
    bottom: 124px !important;
  }

  .pp-ui-title {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding-right: 16px;
  }
</style>
